<template>
    <v-container>
        <v-container class="toolbar__container">
            <v-form ref="form" v-model="formValidado">
                <v-row>
                    <v-col cols="12" sm="6" md="4">
                        <v-datetime-picker
                            v-model="dtInicio"
                            :label="$t('audit.SSFFIntegration.startDate')"
                            :time-picker-props="timePickerProps"
                            :text-field-props="textFieldProps"
                            time-format="HH:mm:ss"
                            date-format="dd/MM/yyyy"
                        ></v-datetime-picker>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <v-datetime-picker
                            v-model="dtFim"
                            :label="$t('audit.SSFFIntegration.endDate')"
                            :time-picker-props="timePickerProps"
                            :text-field-props="textFieldProps"
                            time-format="HH:mm:ss"
                            date-format="dd/MM/yyyy"
                        ></v-datetime-picker>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-btn fab dark color="primary" class="white--text" small @click="search">
                            <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-form>
        </v-container>
        <merus-data-table
            :headers="headers"
            :items="items"
            :show-select="true"
            item-key="name"
            v-model="selectedItems"
        >
            <template v-slot:toolbar>
                <cadastro-toolbar 
                    :title="$t('audit.SSFFIntegration.title')" 
                    :token="token" 
                    :items="items" 
                    hide-search
                >
                    <template v-slot:extension>
                        <v-btn color="primary" class="white--text" small fab @click="downloadSelected">
                            <v-icon>mdi-download</v-icon>
                        </v-btn>
                    </template>
                </cadastro-toolbar>
            </template>

            <template v-slot:item.actions="{ item }">
                <v-icon dark color="blue" small @click="download(item)">mdi-download</v-icon>
            </template>
        </merus-data-table>
    </v-container>
</template>
<script>
import apiController from '@/utils/apiController';
import EventBus from '@/utils/eventBus';
import DateUtils from '@/utils/dateutils';
import MerusDataTable from './Tables/MerusDataTable.vue';
import CadastroToolbar from './Toolbars/CadastroToolbar.vue';

export default {
    components: {
        MerusDataTable,
        CadastroToolbar
    },
    data: () => ({
        user: null,
        token: null,
        dtInicio: null,
        dtFim: null,
        items: [],
        loading: false,
        formValidado: false,
        timePickerProps: {
            useSeconds: true,
        },
        selectedItems: [],
    }),
    created() {
        this.user = JSON.parse(sessionStorage.getItem('user'));
        this.token = sessionStorage.getItem('api');
        this.initialize();
    },
    computed: {
        textFieldProps() {
            return {
                prependInnerIcon: 'mdi-calendar',
                rules: [(v) => !!v || 'Selecione uma data !'],
            }
        },
        headers() {
            return [
                { text: this.$t('audit.SSFFIntegration.headers.file'), value: 'name' },
                { text: this.$t('audit.SSFFIntegration.headers.size'), value: 'size' },
                { text: this.$t('audit.SSFFIntegration.headers.lastModified'), value: 'lastModified' },
                { text: this.$t('audit.SSFFIntegration.headers.actions'), value: 'actions' }];
        }
    },
    methods: {
        initialize() {
            this.getConfig();
        },
        getConfig() {
            apiController.request(apiController.endpoints.getallConfig, {
                onSuccess: response => {
                    [this.dtInicio, this.dtFim] = DateUtils.setDefaultDateFilters(response.data[0].hora_inicial_dia_operacao);
                },
            });
        },
        search() {
            apiController.request(apiController.endpoints.auditGetLogfiles, {
                data: {
                    folder: 'monitor',
                    beginsWith: 'update_from_ssff_to_merus',
                    dti: this.dtInicio.toISOString(),
                    dtf: this.dtFim.toISOString(),
                    user: this.user,
                },
                onSuccess: response => {
                    if (response.data.erro) {
                        EventBus.$emit('show-error', { error: response.data.mensagem });
                    } else {
                        this.items = response.data.files;
                        this.items = this.items.map(item => {
                            return {
                                ...item,
                                size: (item.size ? item.size / 1024 : 0).toFixed(2) + ' KB',
                                lastModified: new Date(item.lastModified)?.toLocaleString().replace(',', ''),
                            }
                        });
                    }
                },
            });
        },
        async handleDownloadBlob(response, filename) {
            const ct = (response.headers['content-type'] || '').split(';')[0].trim();
            if (ct === 'application/json') {
                const text = await response.data.text();
                const data = JSON.parse(text);
                if (data.erro) {
                    EventBus.$emit('show-alert', { mensagem: data.mensagem, tipo: 'error' });
                }
                return;
            }
            const url = window.URL.createObjectURL(response.data);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        },
        async download(item) {
            try {
                const response = await apiController.request(apiController.endpoints.auditDownloadLogfile, {
                    data: {
                        folder: 'monitor',
                        file: item.name,
                        user: this.user,
                    },
                    config: { responseType: 'blob' },
                    silent: true,
                });
                await this.handleDownloadBlob(response, item.name);
            } catch (error) {
                EventBus.$emit('show-error', { error: error });
            }
        },
        async downloadSelected() {
            try {
                const response = await apiController.request(apiController.endpoints.auditDownloadLogfilesbulk, {
                    data: {
                        folder: 'monitor',
                        files: this.selectedItems.map(item => item.name),
                        user: this.user,
                    },
                    config: { responseType: 'blob' },
                    silent: true,
                });
                await this.handleDownloadBlob(response, 'logfiles.zip');
            } catch (error) {
                EventBus.$emit('show-error', { error: error });
            }
        }
    },
}
</script>
<style>

</style>